import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ChatView from '../chatView/components/ChatView';
import { SESSION_TYPES } from '../chatView/constants';
import { getAdminModeEnabled } from '../selectors/user';
import css from '../chatView/components/ChatView.css';

const AnalysisChat = () => {
    const [useV1Agent, setUseV1Agent] = useState(false);
    const isAdminMode = useSelector(getAdminModeEnabled);

    const headerActions = isAdminMode ? (
        <label className={css.agentToggle}>
            <input type="checkbox" checked={useV1Agent} onChange={() => setUseV1Agent(prev => !prev)} />
            <span>V1 Agent</span>
        </label>
    ) : null;

    return (
        <ChatView
            key={useV1Agent ? 'v1' : 'v2'}
            runPath="runs"
            sessionType={SESSION_TYPES.CHAT}
            isV2={!useV1Agent}
            headerActions={headerActions}
        />
    );
};

export default AnalysisChat;
